import { paymentMethods } from '../assets/helpers/options';
import { filterOptionById, validateAndSet } from '../assets/helpers/funciones';
import moment from 'moment';
import { notify } from '../assets/helpers/toast';
import { membershipService } from '../services/membershipService';

const BANK_METHODS = [
  paymentMethods?.TRANSFERENCIA_BANESCO,
  paymentMethods?.TRANSFERENCIA_BANCAMIGA,
  paymentMethods?.TRANSFERENCIA_BANPLUS,
  paymentMethods?.TRANSFERENCIA_BNC,
  paymentMethods?.TRANSFERENCIA_MERCANTIL,
  paymentMethods?.PAGO_MÓVIL_BNC,
  paymentMethods?.PAGO_MOVIL_BANPLUS,
  paymentMethods?.PAGO_MÓVIL_BANCAMIGA,
  paymentMethods?.PAGO_MÓVIL_BANESCO,
  paymentMethods?.PAGO_MÓVIL_MERCANTIL,
  paymentMethods?.PUNTO_DE_VENTA,
];

export default function useProvidersPayment() {

  const getPaymentsData = ({
    paymemtMethodOptions,
    file,
    index,
    watch,
    setValue,
    setIsloading,
    setPayment,
    methodField,
    referenceField,
    dateField,
  }) => {
    // Defaults: convención de ProvidersPayment (method 1-based, reference/date 0-based)
    const methodFieldName = methodField ?? `method${index + 1}`;
    const referenceFieldName = referenceField ?? `reference${index}`;
    const dateFieldName = dateField ?? `date${index}`;

    const currentMethodName = filterOptionById(
      paymemtMethodOptions,
      watch(methodFieldName)
    )?.name;

    const isSupportedMethod =
      paymemtMethodOptions?.length > 0 && BANK_METHODS.includes(currentMethodName);

    setIsloading(true);

    if (!isSupportedMethod) {
      // Sin petición async: difiere el false para que el loader sea perceptible.
      setTimeout(() => setIsloading(false), 600);
      return true;
    }

    const formData = new FormData();
    formData.append('file', file);

    membershipService
      .getPaymentsData(formData)
      .then((response) => {
        if (![200, 201].includes(response.status)) {
          setIsloading(false);
          notify(`${response.message}` || 'error', 'error');
          return;
        }

        const res = response?.data?.[0]?.data;
        const methodNameAfter = filterOptionById(
          paymemtMethodOptions,
          watch(methodFieldName)
        )?.name;

        if (!BANK_METHODS.includes(methodNameAfter)) {
          setIsloading(false);
          notify(`${response.message}` || 'error', 'error');
          return;
        }

        const ref =
          res?.operation_id === null ||
          res?.operation_id === '' ||
          methodNameAfter === paymentMethods?.PUNTO_DE_VENTA
            ? res?.reference_id
            : res?.operation_id;

        validateAndSet(referenceFieldName, ref, setValue, watch);

        if (methodNameAfter === paymentMethods?.PAGO_MÓVIL_BANCAMIGA) {
          validateAndSet(
            dateFieldName,
            new Date(moment(res?.date).endOf('day')),
            setValue,
            watch
          );
        }

        if (typeof setPayment === 'function') {
          setPayment((prevState) => ({ ...prevState, reference: ref }));
        }

        setIsloading(false);
      })
      .catch((error) => {
        console.error('Error al obtener los datos de pago:', error);
        setIsloading(false);
      });
  };

  return {
    getPaymentsData,
  };
}
